var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.191 119.5H0.809019L60 1.11803L119.191 119.5Z",
    stroke: "#C6C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.126 119.5H0.874208L60 18.9862L119.126 119.5Z",
    stroke: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.028 119.5H0.971595L60 36.8602L119.028 119.5Z",
    stroke: "#C6C6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87 119.5H1.13027L60 54.7433L118.87 119.5Z",
    stroke: "#C6C6C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.575 119.5H1.42539L60 72.6403L118.575 119.5Z",
    stroke: "#C6C6C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.882 119.5H2.11804L60 90.559L117.882 119.5Z",
    stroke: "#C6C6C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.95 119.5H5.04951L60 108.51L114.95 119.5Z",
    stroke: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.fd0107e50762f47de1058731011cb0ad.svg";
export { ForwardRef as ReactComponent };